export default __webpack_public_path__ + "static/media/dumbells.c2cc2e74.png";